import { ProjectnetBreadcrumbs } from '../../../lib/propertyTypes';
import ProjectnetTypeNamesTh from '../../../locales/th/projectnetBreadcrumb.json';
import ProjectnetTypeNamesEn from '../../../locales/en/projectnetBreadcrumb.json'; // Adjusted to import from the correct English file

const typeNamesTh: ProjectnetBreadcrumbs = ProjectnetTypeNamesTh;
const typeNamesEn: ProjectnetBreadcrumbs = ProjectnetTypeNamesEn;

export const mapPropertyTypeName = (
  propertyName: string[],
  isProjectnetProject: boolean,
): string[] | null => {
  if (!isProjectnetProject) {
    return propertyName;
  }

  const name = propertyName[0];

  if (name in typeNamesTh.breadcrumbs) {
    return [typeNamesTh.breadcrumbs[name]];
  }

  if (name in typeNamesEn.breadcrumbs) {
    return [typeNamesEn.breadcrumbs[name]];
  }

  return null;
};
